import { getApi, getApiExcel } from 'apis';

const getDashboardSummary = async (params: { payPeriodId: string }) => {
	return await getApi('/dashboard/summary', params);
};

const getDashboardEmployees = async (params: {
	payPeriodId: string;
	search?: string;
	page?: number;
	pageSize?: number;
	sortField?: string;
	sortOrder?: string;
}) => {
	return await getApi('/dashboard/employees', params);
};

const getExpiringContractsExcel = async (payPeriodId: string) => {
	return await getApiExcel('/dashboard/expiring-contracts', { payPeriodId });
};

export const dashboardApi = {
	getDashboardSummary,
	getDashboardEmployees,
	getExpiringContractsExcel,
};
